export default "__VITE_ASSET__Dx9qfXhD__"